export type CacheState = Record<string, unknown>;

export const initialCacheState: CacheState = {};
